module.exports = __webpack_public_path__ + "img/PW.b805f38a.svg";